import { app } from '../app';


export class LoginController {

    static $inject = ['authService', 'returnUrlSanitise', '$stateParams'];

    constructor(authService:any,
                returnUrlSanitise:any,
                $stateParams:any) {

        // We might end up on this page if we are not authenticated
        // Redirect to SSO login
        authService.goToLoginPage($stateParams.returnUrl);
    }
}

app.controller('LoginController', LoginController);
